import { render, staticRenderFns } from "./schedule-view.vue?vue&type=template&id=b9212af4&scoped=true&"
import script from "./schedule-view.vue?vue&type=script&lang=js&"
export * from "./schedule-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9212af4",
  null
  
)

export default component.exports